import React, { useState } from "react";
import HeadwiseReport from "./HeadwiseReport";
import ReceiptPaymentReport from "./ReceiptPaymentReport";
import AccountStatementReport from "./AccountStatementReport";
import ProfitLossReport from "./ProfitLossReport";
import MonthlySummaryReport from "./MonthlySummaryReport";
import DailyJournal from "./DailyJournal";

export default function ReportsTab({ token, finYear }) {
  const [selected, setSelected] = useState("headwise");

  const reportButtons = [
    { key: "headwise", label: "Headwise" },
    { key: "receiptPayment", label: "Receipt & Payment" },
    { key: "accountStatement", label: "Account Statement" },
    { key: "profitLoss", label: "Profit & Loss" },
    { key: "monthlySummary", label: "Monthly Summary" },
    { key: "dailyJournal", label: "Daily Journal" },
    // Add more report config objects here as needed
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2>Reports</h2>
      <div style={{ marginBottom: 16, display: "flex", flexWrap: "wrap", gap: 8 }}>
        {reportButtons.map((btn) => (
          <button
            key={btn.key}
            onClick={() => setSelected(btn.key)}
            className={selected === btn.key ? "active" : ""}
            style={{
              padding: "6px 16px",
              background: selected === btn.key ? "#224488" : "#eee",
              color: selected === btn.key ? "#fff" : "#222",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            {btn.label}
          </button>
        ))}
      </div>
      <div>
        {selected === "headwise" && <HeadwiseReport token={token} finYear={finYear} />}
        {selected === "receiptPayment" && <ReceiptPaymentReport token={token} finYear={finYear} />}
        {selected === "accountStatement" && <AccountStatementReport token={token} finYear={finYear} />}
        {selected === "profitLoss" && <ProfitLossReport token={token} />}
        {selected === "monthlySummary" && <MonthlySummaryReport token={token} finYear={finYear} />}
        {selected === "dailyJournal" && <DailyJournal token={token} finYear={finYear} />}
        {/* Add more report components as you add more reports */}
      </div>
    </div>
  );
}